module.exports = __webpack_public_path__ + "img/kuspit.f81d816c.svg";